import { localeApi } from "src/services/api";
import { isLangAbsent, redirectWithLang } from "./utils/loader-utils";

export async function loader({ request }) {
  if (isLangAbsent(request)) return redirectWithLang(request, window.location.hash);
  // Check if localStorage and sessionStorage are available
  const storageAvailable = (type) => {
    let storage;
    try {
      storage = window[type];
      const test = "__storage_test__";
      storage.setItem(test, test);
      storage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  const isLocalStorageAvailable = storageAvailable("localStorage");
  const isSessionStorageAvailable = storageAvailable("sessionStorage");

  if (!isLocalStorageAvailable || !isSessionStorageAvailable) {
    return { isLocalStorageAvailable, isSessionStorageAvailable };
  }

  const lang = new URL(request.url).searchParams.get("lang");

  const strings = await localeApi
    .getStringResources(lang)
    .then((data) => data.data)
    .catch((err) => {
      console.error(err);
      return {};
    });

  return {
    isLocalStorageAvailable,
    isSessionStorageAvailable,
    strings,
    lang,
  };
}
